import React from "react";
import { Tab, Tabs } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";

// Collection sites and the groups they are put in, side by side.
export const SitesTabs = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const value = pathname.startsWith(ROUTES.siteGroups) ? ROUTES.siteGroups : ROUTES.trapSite;
  return (
    <Tabs
      value={value}
      onChange={(_, next) => history.push(next)}
      variant="fullWidth"
      sx={{ borderBottom: 1, borderColor: "divider", minHeight: 40, "& .MuiTab-root": { minHeight: 40 } }}
    >
      <Tab label="Collection sites" value={ROUTES.trapSite} />
      <Tab label="Site groups" value={ROUTES.siteGroups} />
    </Tabs>
  );
};
